import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import { createQueryClient } from "@solarkey/api-client";

import { AuthedApp } from "./auth/AuthedApp";
import { AuthProvider } from "./auth/AuthProvider";
import { IntlRoot } from "./i18n/IntlRoot";
import { router } from "./router/router";

// One client for the app's lifetime. Push invalidation (SSE) drives freshness, not focus refetch.
const queryClient = createQueryClient();

const isEdge = import.meta.env.MODE === "edge";

/**
 * App root. Two modes:
 *
 *   - Cloud (default): QueryClient → i18n → auth → capabilities gate → full router.
 *   - Edge  (`--mode edge`): QueryClient → i18n → router directly. No auth, no
 *     capabilities — the edge node is behind the site LAN, and the EdgeLayout
 *     doesn't need session/capabilities context.
 */
export function App() {
  if (isEdge) {
    return (
      <QueryClientProvider client={queryClient}>
        <IntlRoot>
          <RouterProvider router={router} />
        </IntlRoot>
      </QueryClientProvider>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <IntlRoot>
        <AuthProvider>
          <AuthedApp />
        </AuthProvider>
      </IntlRoot>
    </QueryClientProvider>
  );
}
